var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphicsSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162.16,
    height: 139.513,
    viewBox: "0 0 162.16 139.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "graphics_sm-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 162.16,
    height: 139.513,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_183",
    "data-name": "Groupe 183",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_182",
    "data-name": "Groupe 182",
    transform: "translate(0 0)",
    clipPath: "url(#graphics_sm-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_255",
    "data-name": "Trac\\xE9 255",
    d: "M19.851,33.985c-14.871,16-14.032,41.129-9.269,52.078,5.9,13.55,18.006,22.059,26.373,26.371,20.177,10.4,59.885,20.185,80.539-.357,29.492-29.331-15.949-166-97.643-78.091",
    transform: "translate(7.81 5.112)",
    fill: "#d1e8e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_256",
    "data-name": "Trac\\xE9 256",
    d: "M12.125,7.729a8.419,8.419,0,0,0-6.958,4.6,8.993,8.993,0,0,0-.147,5.88c1,3.436,4.2,9.038,8.8,9.164,6.557.182,17.235-19.87-1.692-19.648",
    transform: "translate(4.785 8.047)",
    fill: "#b3ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_257",
    "data-name": "Trac\\xE9 257",
    d: "M41.154,37.014c2.572-11.592,13.47-24.26,25.064-21.685l41.7,5.882c11.592,2.574,13.523,16.245,10.949,27.836A21.5,21.5,0,0,1,93.211,65.373l-29.07-6.455A62.8,62.8,0,0,1,52.256,65.4a.855.855,0,0,1-.892-1.431,14.784,14.784,0,0,0,3.505-3.957,14,14,0,0,0,1.28-2.889c-11.157-2.893-17.516-8.768-15-20.109",
    transform: "translate(42.292 15.614)",
    fill: "#1d7b91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_258",
    "data-name": "Trac\\xE9 258",
    d: "M60.915,37.053l-7.186-6.265.041,1.841,6.9-6.578c1.286-1.225-.81-3.024-2.1-1.8l-6.9,6.578a1.228,1.228,0,0,0,.041,1.841L58.9,38.939c1.345,1.17,3.358-.719,2.017-1.886",
    transform: "translate(53.405 24.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_259",
    "data-name": "Trac\\xE9 259",
    d: "M65.306,25.872l7.186,6.265L72.451,30.3l-6.9,6.578c-1.288,1.225.811,3.024,2.1,1.8l6.9-6.578a1.228,1.228,0,0,0-.041-1.841l-7.186-6.265c-1.345-1.17-3.358.719-2.017,1.886",
    transform: "translate(67.558 24.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_260",
    "data-name": "Trac\\xE9 260",
    d: "M60.206,44.81,69.64,23.647c.688-1.543-1.848-2.815-2.542-1.26L57.664,43.55c-.686,1.543,1.85,2.815,2.542,1.26",
    transform: "translate(59.939 22.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_261",
    "data-name": "Trac\\xE9 261",
    d: "M.139,35.81,21.381,46.091,24.915,65.21,46.419,76.5l3.742,25.668-45-24.254Z",
    transform: "translate(0.145 37.296)",
    fill: "#00d6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_262",
    "data-name": "Trac\\xE9 262",
    d: "M52.251,29.488,34.286,45.824l3.262,21.232L22.861,80.9l5.13,26.475L59.958,76.39Z",
    transform: "translate(23.811 30.712)",
    fill: "#1d7b91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_263",
    "data-name": "Trac\\xE9 263",
    d: "M75.639,38.745C61.45,33.151,47.453,27.964,33.758,22.651l1.076-.188L2.749,52.113,2.309,49.4c13.558,5.216,26.869,11.012,40.11,16.971l-2.158.329c11.006-9.224,23.986-18.956,35.378-27.955m.4-.065C66.209,48.032,53.1,60.918,42.941,69.8a2.006,2.006,0,0,1-2.158.329C27.391,64.521,14.072,58.748,1.006,52.4a1.632,1.632,0,0,1-.441-2.713c.02-.006,32.9-28.773,32.918-28.773a1,1,0,0,1,1.053-.165c14.1,6.033,27.9,12.186,41.5,17.935",
    transform: "translate(0.021 21.521)",
    fill: "#00d6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_264",
    "data-name": "Trac\\xE9 264",
    d: "M53.99,30.775c1.035,14.934,2.93,29.8,5.4,44.553l.621-1.86c-9.387,9.269-22.784,22.706-32.316,32.1l2.056.688c-2.866-14.779-5.265-30.131-8.574-44.6,1.523,14.789,4.13,30.072,6.155,45a1.225,1.225,0,0,0,2.056.686L46.132,91.9c5.592-5.134,11.249-10.2,16.781-15.4a2.064,2.064,0,0,0,.629-1.819C61.788,63.6,59.6,52.575,57.089,41.626c-.808-3.654-1.731-7.288-2.7-10.916a.205.205,0,0,0-.4.065",
    transform: "translate(22.054 31.832)",
    fill: "#00d6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_265",
    "data-name": "Trac\\xE9 265",
    d: "M.049,35.655C-.109,48.378,0,65.131,2.274,77.611a1.76,1.76,0,0,0,.935,1.364c7.352,3.756,26.262,13.409,33.418,16.961L47.8,101.519c.212.112.425-.229.2-.357l-10.732-6.4C30.5,90.7,12.02,79.891,4.963,75.767L5.9,77.133C4.861,64.488,3.907,47.849.453,35.6a.207.207,0,0,0-.4.053",
    transform: "translate(0 36.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_266",
    "data-name": "Trac\\xE9 266",
    d: "M46.678,41.846c-1.676-.659-1.95.663-3.583.21-4.9-1.354-11.016-3.916-15.867-5.8l.508-.09L12.252,48.161l-.208-1.282c6.4,2.464,12.69,5.2,18.946,8.015l-1.019.155c5.2-4.355,11.326-8.952,16.708-13.2m.19-.031c-4.645,4.418-10.834,10.5-15.634,14.7a.948.948,0,0,1-1.019.155C23.89,54.02,17.6,51.295,11.429,48.294a.769.769,0,0,1-.208-1.28c.008,0,15.54-13.591,15.546-13.591a.477.477,0,0,1,.5-.078C32.3,35.5,37.254,37.686,42.148,39.8q2.37,1.023,4.72,2.017",
    transform: "translate(11.418 34.69)",
    fill: "#00d6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_267",
    "data-name": "Trac\\xE9 267",
    d: "M37.568,38.064c.488,7.054,1.384,14.072,2.55,21.042l.292-.878c-4.432,4.377-10.761,10.724-15.263,15.158l.972.325c-1.354-6.98-3.1-16.833-4.661-23.668.239,2.323-1.633-.808-1.309,1.552.649,4.736,3.3,17.455,3.934,22.159.055.453,1.55.8,1.864.47l7.909-7.288c2.642-2.425,5.312-4.818,7.925-7.272a.97.97,0,0,0,.3-.859c-.829-5.237-1.862-10.445-3.048-15.616-.382-1.725-.817-3.442-1.274-5.155a.1.1,0,0,0-.19.031",
    transform: "translate(20.947 39.541)",
    fill: "#00d6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_268",
    "data-name": "Trac\\xE9 268",
    d: "M10.707,41.351A92.9,92.9,0,0,0,12.289,59.2a.827.827,0,0,0,.443.643c3.473,1.774,12.4,6.333,15.783,8.011l5.279,2.638c.1.053.2-.108.092-.169A4.324,4.324,0,0,0,32.1,67.9c-1.113-.663-15.2-7.621-18.535-9.569l.441.645a92.912,92.912,0,0,0-3.1-17.647.1.1,0,0,0-.192.024",
    transform: "translate(11.145 42.972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_269",
    "data-name": "Trac\\xE9 269",
    d: "M41.1,40.55l-15.869-5.8-12.359,9.83L28,51.156Z",
    transform: "translate(13.41 36.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_270",
    "data-name": "Trac\\xE9 270",
    d: "M57.255,11.646,41.14,1.34,23.825,7.012,38.943,19.947Z",
    transform: "translate(24.815 1.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_271",
    "data-name": "Trac\\xE9 271",
    d: "M57.514,13.041c-1.339-1.051-1.946.073-3.3-.776C50.142,9.718,45.287,5.747,41.4,2.736l.486.055L24.621,9.479l.155-1.217c5.139,3.959,10.1,8.134,15,12.37l-.964-.133c4.291-1.858,11.663-6.464,16.269-8.254a1.845,1.845,0,0,1,2.429.8m-.114.174c-5.4,2.75-12.353,6.445-17.833,8.954a.9.9,0,0,1-.966-.135C33.585,17.927,28.62,13.76,23.839,9.377a.727.727,0,0,1,.155-1.217C24,8.16,41.739.037,41.745.041A.452.452,0,0,1,42.219.1C46.2,3.413,50.1,6.729,53.964,9.963c1.245,1.043,2.574,1.978,3.816,3Z",
    transform: "translate(24.556 -0.001)",
    fill: "#00d6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_272",
    "data-name": "Trac\\xE9 272",
    d: "M51.3,6.5c-1.46,6.523-2.45,14-3.273,20.63l.5-.717c-5.2,2.77-12.641,6.815-17.917,9.62l.792.555c.657-6.69,1.733-16.087,2.16-22.7-.408,2.17-1.262-1.174-1.6,1.053-.688,4.465-1.719,16.7-2.409,21.138-.074.425,1.186,1.139,1.562.927l9.132-4.471c3.046-1.486,6.112-2.934,9.142-4.451a.926.926,0,0,0,.5-.7c.661-4.969,1.129-9.965,1.449-14.971.118-1.666.1-4.216.145-5.892,0-.1-.182-.022-.182-.022",
    transform: "translate(30.773 6.742)",
    fill: "#00d6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_273",
    "data-name": "Trac\\xE9 273",
    d: "M24.816,5.089a87.669,87.669,0,0,0-3.379,16.6.79.79,0,0,0,.227.7C24.332,24.935,31.2,31.474,33.8,33.905l4.071,3.814c.078.073.21-.045.129-.129a4.086,4.086,0,0,0-.968-2.683c-.829-.9-11.718-11-14.213-13.666l.227.7A87.719,87.719,0,0,0,25,5.117a.092.092,0,0,0-.18-.029",
    transform: "translate(22.315 5.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_274",
    "data-name": "Trac\\xE9 274",
    d: "M32.44,14.727,51.018,6.351,48.84,28.214l-18.772,7.95Z",
    transform: "translate(31.317 6.614)",
    fill: "#00d6de"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicsSm);
export default __webpack_public_path__ + "static/media/graphics_sm.25dbf6c276d8261e70b9a9a96c832b78.svg";
export { ForwardRef as ReactComponent };